import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import ThesaurusGroupsList from '../ThesaurusGroupsList';

import './ThesaurusGroupsRoot.scss';

function ThesaurusGroupsRoot(props) {
  const { filter, expandSearchOptions } = props;

  if (!filter) {
    return null;
  }

  const thesaurusRootId = filter.get('thesaurusRootId');

  if (!thesaurusRootId) {
    return null;
  }

  const displayNone = expandSearchOptions
    ? {
        display: 'none',
      }
    : {};

  return (
    <section style={displayNone} className="tree-view-dialog-thesaurus-root-wrapper">
      <div className="tree-view-dialog-thesaurus-root">
        <ThesaurusGroupsList {...props} identificatorOfBatchItems={thesaurusRootId} item={filter} />
      </div>
    </section>
  );
}

ThesaurusGroupsRoot.propTypes = {
  expandSearchOptions: PropTypes.bool.isRequired,
  filter: PropTypes.instanceOf(Map),
};

export default ThesaurusGroupsRoot;
